import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
  },
  header: {
    fontWeight: 'bolder',
    fontSize: '16px',
    lineHeight: '19px',
    color: '#2C2D3E',
    marginTop: 2,
    marginBottom: 14,
    fontFamily: 'Roboto',
  },
  infoBox: {
    position: 'sticky',
    alignSelf: 'flex-end',
    fontSize: '12px',
    lineHeight: '14px',
    color: '#2C2D3E',
    zIndex: 100,
    top: '0px',
    boxSizing: 'border-box',
    borderRadius: '5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minWidth: '334px',
    width: 'auto',
    padding: '2px 2px 2px 2px',
  },
  infoBoxSuccess: {
    background: 'rgba(52, 127, 66, 0.1)',
    border: '1px solid rgba(52, 127, 66, 0.15)',
  },
  infoBoxError: {
    background: '#FFE2E2',
    border: '1px solid rgba(188, 0, 0, 0.2)',
  },

  infoBoxText: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
  },
  infoBoxCloseIcon: {
    cursor: 'pointer',
  },
  actions: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: '10px',
    gap: '10px',
  },
  row: {
    padding: '1px 1px 1px 1px',
  },
  invalidRow: {
    border: 'none',
  },
  invalidRowCell: {
    paddingTop: '1px',
    paddingBottom: '1px',
    fontSize: '12px',
    textAlign: 'center',
    color: '#BC0000',
    background: '#FFE2E2',
    border: 'none',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
  },
  textCell: {
    fontWeight: 'bolder',
    fontSize: '1rem',
    lineHeight: '14px',
    color: '#3C419A',
    width: 'auto',
    whiteSpace: 'initial',
    wordWrap: 'break-word',
  },
  headerCell: {
    fontWeight: 'bolder',
    fontSize: '12px',
    lineHeight: '14px',
    color: '#2C2D3E',
    background: '#ffffff',
    padding: '10px 10px',
  },
  headerCellNoBorder: {
    fontWeight: 'bolder',
    fontSize: '12px',
    lineHeight: '14px',
    color: '#2C2D3E',
    background: '#ffffff',
    padding: '10px 10px',
    borderBottom: '0px',
  },
  customTooltip: {
    backgroundColor: '#2C2D3E',
  },
  customArrow: {
    color: '#2C2D3E',
  },
  checkbox: {
    margin: '-4px',
    '& .MuiSvgIcon-root': { fontSize: 20 },
  },
  textField: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#3560FF',
        padding: '1px 1px 1px 1px',
      },
    },
  },
  infoRowCell: {
    marginTop: 10,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'left',
    height: 50,
    paddingTop: '1px',
    paddingBottom: '1px',
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'center',
    color: '#2C2D3E',
    background: 'rgba(53, 96, 255, 0.1)',
    borderRadius: '4px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
  },
}));
